// extracted by mini-css-extract-plugin
export var standaloneTable = "_h0-0";
export var withExtraHeader = "_h0-1";